export default "__VITE_ASSET__DCb292jl__"